import { render } from "./CategoryPlatform.vue?vue&type=template&id=575b9f82"
import script from "./CategoryPlatform.vue?vue&type=script&lang=js"
export * from "./CategoryPlatform.vue?vue&type=script&lang=js"

import "./CategoryPlatform.vue?vue&type=style&index=0&id=575b9f82&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__